module.exports = __webpack_public_path__ + "static/media/balance-scale-right.28c7f5f2.svg";